/* unplugin-vue-components disabled */import script from "./mg-editor-form.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-editor-form.vue?vue&type=script&setup=true&lang=js"

import "./mg-editor-form.vue?vue&type=style&index=0&id=abb64a12&lang=less"

const __exports__ = script;

export default __exports__